import PartnerList from '../components/Partners/PartnerList';

export default function PartnerListPage() {
  return <PartnerList />;
}
